<template>
  <div id="app" :class="{'is-chrome': isChrome}">
    <router-view/>
  </div>
</template>
<script>
  export default {
    name: 'App',
    computed: {
      isChrome () {
        return navigator.userAgent.indexOf("CriOS") !== -1
      }
    }
  }
</script>
